// removed by extract-text-webpack-plugin
module.exports = {"header":"cdB8vBaaqi0gbFcc-kVyD","title-label":"_37xB6whXlPJnZyDIRGntAC","titleLabel":"_37xB6whXlPJnZyDIRGntAC","close":"rkqICN-1y_nDne-6oXkLm","red":"_2L_ruJ7Sq8dHvtkY-EL7f4","blue":"_38PM0D5IZ0fyu9HQ7Hg2gz","green":"_18nLIJmf9AiUgcvKTea3Qf","lightGreen":"_2VeGEcct-uPFw95pwe7Ej4"};


//////////////////
// WEBPACK FOOTER
// ./~/wix-style-react/dist/es/src/MessageBox/HeaderLayout.scss
// module id = ./node_modules/wix-style-react/dist/es/src/MessageBox/HeaderLayout.scss
// module chunks = 0